import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { CoreModule } from './core.module';
import { MaterialModule } from './material.module';
import { CommonErrorMessageDialogComponent } from './common-dialog/common-error-message-dialog.component';
import { CommonSaveConfirmDialogComponent } from './common-dialog/common-save-confirm-dialog.component';
import { CommonConfirmDialogComponent } from './common-dialog/common-confirm-dialog.component';
import { CommonDeleteDialogComponent } from './common-dialog/common-delete-dialog.component';
import { SearchComboBoxComponent } from './_shared/component/search-combo-box/search-combo-box.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { InspectionUpsertDialogComponent } from './inspection/dialogs/inspection-upsert-dialog/inspection-upsert-dialog.component';
import { DataUploadDialogComponent } from './inspection/dialogs/data-upload-dialog/data-upload-dialog.component';
import { UploadConfirmDialogComponent } from './inspection/dialogs/upload-confirm-dialog/upload-confirm-dialog.component';
import { UploadProgressDialogComponent } from './inspection/dialogs/upload-progress-dialog/upload-progress-dialog.component';
import { FirstActionGuideDialogComponent } from './inspection/dialogs/first-action-guide-dialog/first-action-guide-dialog.component';
import { TranslateLoader, TranslateModule, TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ImageConflictDialogComponent } from './inspection/dialogs/image-conflict-dialog/image-conflict-dialog.component';
import { CustomUserNamePipe } from './_shared/pipes/user-name.pipe';
import { SaveIplexGImagesComponent } from './inspection/dialogs/data-upload-dialog/save-iplex-g-images/save-iplex-g-images.component';
import { FileSizePipe } from './_shared/pipes/file-size.pipe';
import { TimeCountPipe } from './_shared/pipes/time-count.pipe';
import { TimeUnitPipe } from './_shared/pipes/time-unit.pipe';
import { ImageTrimComponent } from './_shared/component/image-trim/image-trim.component';
import { FilterSelectDialogComponent } from './_shared/dialog/filter-select-dialog/filter-select-dialog.component';
import { NavButtonComponent, SvgIconComponent } from "@evc/web-components";
import { Observable } from 'rxjs';

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "/assets/i18n/app/", ".json");
}

const translateModuleConfig: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: httpLoaderFactory,
    deps: [HttpClient]
  },
  extend: true,
  isolate: false
};

export const translateModule = TranslateModule.forRoot(translateModuleConfig);

@NgModule({
  declarations: [
    // Dialog Component
    CommonErrorMessageDialogComponent,
    CommonSaveConfirmDialogComponent,
    CommonConfirmDialogComponent,
    CommonDeleteDialogComponent,
    InspectionUpsertDialogComponent,
    DataUploadDialogComponent,
    FilterSelectDialogComponent,
    // Component
    SearchComboBoxComponent,
    ImageTrimComponent,
    UploadConfirmDialogComponent,
    ImageConflictDialogComponent,
    UploadProgressDialogComponent,
    FirstActionGuideDialogComponent,
    SaveIplexGImagesComponent,
    // Pipe
    CustomUserNamePipe,
    FileSizePipe,
    TimeCountPipe,
    TimeUnitPipe,
  ],
  imports: [
    CommonModule,
    ColorPickerModule,
    FormsModule,
    FlexLayoutModule,
    MaterialModule,
    MatExpansionModule,
    NavButtonComponent,
    ReactiveFormsModule,
    SvgIconComponent,
    translateModule,
  ],
  exports: [
    // Module
    CoreModule,
    CommonModule,
    ColorPickerModule,
    FormsModule,
    FlexLayoutModule,
    MaterialModule,
    MatExpansionModule,
    ReactiveFormsModule,
    // Component
    SearchComboBoxComponent,
    ImageTrimComponent,
    InspectionUpsertDialogComponent,
    DataUploadDialogComponent,
    UploadConfirmDialogComponent,
    ImageConflictDialogComponent,
    UploadProgressDialogComponent,
    FirstActionGuideDialogComponent,
    FilterSelectDialogComponent,
    SaveIplexGImagesComponent,
    // Pipe
    CustomUserNamePipe,
    FileSizePipe,
    TimeCountPipe
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedModule { }
